/* =============================================================
   Tante Reine — Navigation swatches cross-produits
   Thème : Symmetry 8.0.0

   Source de vérité : window.tantereineSwatches injecté par
   le snippet Liquid tantereine-swatch-data.liquid, lui-même
   alimenté par les collections Shopify + le metafield "Couleur".
   ============================================================= */

(function () {
  'use strict';

  // ─── Sélecteurs CSS — Symmetry 8.0.0 ───────────────────────────────────────
  var SEL = {
    title:       'h1, .product-meta h1, .product__title',
    sliderItems: '.main-image .slider__item',
    slider:      '.main-image .slider',
    variantId:   'input[name="id"], [data-product-select] option[selected], select[name="id"]',
    price:       '.product-meta__price, .price, .product__price, [data-product-price]',
  };

  // ─── Utilitaires ────────────────────────────────────────────────────────────
  function $first(selector) {
    var parts = selector.split(',');
    for (var i = 0; i < parts.length; i++) {
      var el = document.querySelector(parts[i].trim());
      if (el) return el;
    }
    return null;
  }

  function getLocalePrefix() {
    var match = window.location.pathname.match(/^(\/[a-z]{2}-[a-z]{2})\//);
    return match ? match[1] : '';
  }

  function getCurrentHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : null;
  }

  // Construit une map plate { handle: { group, groupLabel, label, image, template, products } }
  var _productMap = null;
  function getProductMap() {
    if (_productMap) return _productMap;
    _productMap = {};
    var data = window.tantereineSwatches || {};
    for (var groupKey in data) {
      var group = data[groupKey];
      var products = group.products || [];
      products.forEach(function (p) {
        _productMap[p.handle] = {
          groupKey: groupKey,
          groupLabel: group.label,
          label: p.label,
          image: p.image,
          template: p.template,
          handle: p.handle,
          products: products
        };
      });
    }
    return _productMap;
  }

  function findProduct(handle) {
    return getProductMap()[handle] || null;
  }

  // ─── Cache d'images (fallback featured_image) ───────────────────────────────
  function getCachedImage(handle) {
    try { return sessionStorage.getItem('tr_swatch_' + handle); }
    catch (e) { return null; }
  }

  function setCachedImage(handle, url) {
    try { sessionStorage.setItem('tr_swatch_' + handle, url); }
    catch (e) {}
  }

  // Source prioritaire : metafield Couleur (déjà dans window.tantereineSwatches)
  // Fallback : featured_image du produit via l'API /products/handle.js
  async function getSwatchImage(handle, locale) {
    var entry = findProduct(handle);
    if (entry && entry.image) {
      return (entry.image.indexOf('//') === 0 ? 'https:' : '') + entry.image;
    }

    var cached = getCachedImage(handle);
    if (cached) return cached;

    try {
      var resp = await fetch(locale + '/products/' + handle + '.js');
      var data = await resp.json();
      var img = data.featured_image;
      if (img) {
        var full = (img.indexOf('//') === 0 ? 'https:' : '') + img;
        setCachedImage(handle, full);
        return full;
      }
    } catch (e) {}
    return null;
  }

  // ─── Navigation vers un autre produit (AJAX) ───────────────────────────────
  async function navigateTo(product) {
    var locale = getLocalePrefix();
    var newUrl = locale + '/products/' + product.handle;

    window.history.pushState({ handle: product.handle }, product.label, newUrl);
    document.title = product.label;

    var titleEl = $first(SEL.title);
    if (titleEl) titleEl.textContent = product.label;

    try {
      var resp = await fetch(locale + '/products/' + product.handle + '.js');
      var data = await resp.json();

      if (titleEl && data.title) titleEl.textContent = data.title;

      var priceEl = $first(SEL.price);
      if (priceEl && data.price) {
        priceEl.textContent = (data.price / 100).toLocaleString('fr-BE', {
          style: 'currency', currency: 'EUR'
        });
      }

      // Met à jour TOUS les inputs variant ID (formulaire principal,
      // sticky ATC, formulaire de paiement échelonné, etc.) sinon le
      // bouton "Ajouter au panier" peut envoyer l'ancien produit.
      // Pour les produits avec tailles, on essaie de conserver la taille
      // actuellement sélectionnée.
      if (data.variants && data.variants.length) {
        var newVariantId = data.variants[0].id;
        if (data.variants.length > 1) {
          var checkedRadio = document.querySelector('input[type="radio"].js-option:checked, input[type="radio"][name*="option"]:checked');
          var currentSize = checkedRadio ? checkedRadio.value : null;
          if (currentSize) {
            for (var i = 0; i < data.variants.length; i++) {
              var v = data.variants[i];
              if (v.option1 === currentSize || v.option2 === currentSize || v.option3 === currentSize) {
                newVariantId = v.id;
                break;
              }
            }
          }
        }
        document.querySelectorAll('input[name="id"]').forEach(function (input) {
          input.value = newVariantId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        document.querySelectorAll('select[name="id"]').forEach(function (sel) {
          sel.value = newVariantId;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
        document.querySelectorAll('[data-product-id]').forEach(function (el) {
          el.setAttribute('data-product-id', data.id);
        });
      }

      // Galerie photos
      if (data.images && data.images.length) {
        var sliderItems = document.querySelectorAll(SEL.sliderItems);
        if (sliderItems.length > 0) {
          sliderItems.forEach(function (item, idx) {
            var img = item.querySelector('img');
            if (!img) return;
            if (data.images[idx]) {
              var base = (data.images[idx].indexOf('//') === 0 ? 'https:' : '') + data.images[idx];
              img.src = base + '&width=1600';
              img.srcset = base + '&width=340 340w, ' + base + '&width=740 740w, ' + base + '&width=1600 1600w';
              img.removeAttribute('sizes');
              item.style.display = '';
            } else {
              item.style.display = 'none';
            }
          });
          var slider = document.querySelector(SEL.slider);
          if (slider) slider.scrollLeft = 0;
          sliderItems.forEach(function (item, idx) {
            item.classList.toggle('is-active', idx === 0);
          });
        }
      }

      if (data.featured_image) {
        var full = (data.featured_image.indexOf('//') === 0 ? 'https:' : '') + data.featured_image;
        setCachedImage(product.handle, full);
      }

    } catch (err) {
      window.location.href = newUrl;
      return;
    }

    // Swatch actif
    document.querySelectorAll('.tr-swatch').forEach(function (s) {
      var isActive = s.dataset.handle === product.handle;
      s.classList.toggle('tr-swatch--active', isActive);
      s.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  // ─── Construction des swatches ──────────────────────────────────────────────
  function buildSwatches(currentEntry) {
    var wrap = document.createElement('div');
    wrap.className = 'tr-swatches';
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Choisir un coloris');
    var locale = getLocalePrefix();

    currentEntry.products.forEach(function (product) {
      var isCurrent = product.handle === currentEntry.handle;

      var a = document.createElement('a');
      a.className = 'tr-swatch' + (isCurrent ? ' tr-swatch--active' : '');
      a.setAttribute('data-handle', product.handle);
      a.href = locale + '/products/' + product.handle;
      a.setAttribute('title', product.label);
      a.setAttribute('aria-label', 'Coloris ' + product.label);
      a.setAttribute('aria-current', isCurrent ? 'true' : 'false');

      getSwatchImage(product.handle, locale).then(function (url) {
        if (url) {
          var sep = url.indexOf('?') === -1 ? '?' : '&';
          a.style.backgroundImage = 'url(' + url + sep + 'width=80)';
        }
      });

      a.addEventListener('click', function (e) {
        if (a.classList.contains('tr-swatch--active')) {
          e.preventDefault();
          return;
        }
        // Si le template change (ex: précommande → dispo), rechargement complet
        var targetTpl = (product.template || '');
        var currentTpl = (currentEntry.template || '');
        if (currentTpl !== targetTpl) return;
        e.preventDefault();
        navigateTo(product);
      });

      wrap.appendChild(a);
    });

    return wrap;
  }

  // ─── Point d'entrée ─────────────────────────────────────────────────────────
  function init() {
    if (!window.location.pathname.includes('/products/')) return;

    var handle = getCurrentHandle();
    if (!handle) return;

    var entry = findProduct(handle);
    if (!entry) return; // Ce produit n'appartient à aucune gamme

    var titleEl = $first(SEL.title);
    if (!titleEl) {
      console.warn('[Tante Reine Swatches] Titre produit introuvable. Vérifier les sélecteurs CSS.');
      return;
    }

    var swatches = buildSwatches(entry);
    titleEl.insertAdjacentElement('afterend', swatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.handle) {
      var entry = findProduct(e.state.handle);
      if (entry) navigateTo(entry);
    }
  });

})();
